/**
 * Scriptures cited in manual-aligned lessons, new-member guide, and similar content.
 * Canonical English text from Church of Jesus Christ of Latter-day Saints scriptures.
 */
import type { Scripture } from './scriptures';

export const manualTrainingScripturesEn: Scripture[] = [
  {
    id: '2-nephi-25-26',
    reference: '2 Nephi 25:26',
    text: 'And we talk of Christ, we rejoice in Christ, we preach of Christ, we prophesy of Christ, and we write according to our prophecies, that our children may know to what source they may look for a remission of their sins.',
    verses: [
      {
        verse: 26,
        text: 'And we talk of Christ, we rejoice in Christ, we preach of Christ, we prophesy of Christ, and we write according to our prophecies, that our children may know to what source they may look for a remission of their sins.',
      },
    ],
    context: 'Nephi teaches to center teaching and hearts on the Savior.',
  },
  {
    id: '2-nephi-31-17-20',
    reference: '2 Nephi 31:17–20',
    text: 'Wherefore, do the things which I have told you I have seen that your Lord and your Redeemer should do; for, for this cause have they been shown unto me, that ye might know the gate by which ye should enter. For the gate by which ye should enter is repentance and baptism by water; and then cometh a remission of your sins by fire and by the Holy Ghost. And then are ye in this strait and narrow path which leads to eternal life; yea, ye have entered in by the gate; ye have done according to the commandments of the Father and the Son; and ye have received the Holy Ghost, which witnesses of the Father and the Son, unto the fulfilling of the promise which he hath made, that if ye entered in by the way ye should receive. And now, my beloved brethren, after ye have gotten into this strait and narrow path, I would ask if all is done? Behold, I say unto you, Nay; for ye have not come thus far save it were by the word of Christ with unshaken faith in him, relying wholly upon the merits of him who is mighty to save. Wherefore, ye must press forward with a steadfastness in Christ, having a perfect brightness of hope, and a love of God and of all men. Wherefore, if ye shall press forward, feasting upon the word of Christ, and endure to the end, behold, thus saith the Father: Ye shall have eternal life.',
    verses: [
      {
        verse: 17,
        text: 'Wherefore, do the things which I have told you I have seen that your Lord and your Redeemer should do; for, for this cause have they been shown unto me, that ye might know the gate by which ye should enter. For the gate by which ye should enter is repentance and baptism by water; and then cometh a remission of your sins by fire and by the Holy Ghost.',
      },
      {
        verse: 18,
        text: 'And then are ye in this strait and narrow path which leads to eternal life; yea, ye have entered in by the gate; ye have done according to the commandments of the Father and the Son; and ye have received the Holy Ghost, which witnesses of the Father and the Son, unto the fulfilling of the promise which he hath made, that if ye entered in by the way ye should receive.',
      },
      {
        verse: 19,
        text: 'And now, my beloved brethren, after ye have gotten into this strait and narrow path, I would ask if all is done? Behold, I say unto you, Nay; for ye have not come thus far save it were by the word of Christ with unshaken faith in him, relying wholly upon the merits of him who is mighty to save.',
      },
      {
        verse: 20,
        text: 'Wherefore, ye must press forward with a steadfastness in Christ, having a perfect brightness of hope, and a love of God and of all men. Wherefore, if ye shall press forward, feasting upon the word of Christ, and endure to the end, behold, thus saith the Father: Ye shall have eternal life.',
      },
    ],
    context: 'Nephi teaches repentance, baptism, the Holy Ghost, and enduring in Christ.',
  },
  {
    id: '1-corinthians-15-29',
    reference: '1 Corinthians 15:29',
    text: 'Else what shall they do which are baptized for the dead, if the dead rise not at all? why are they then baptized for the dead?',
    verses: [
      {
        verse: 29,
        text: 'Else what shall they do which are baptized for the dead, if the dead rise not at all? why are they then baptized for the dead?',
      },
    ],
    context: 'Paul teaches the reality of the resurrection in connection with work for the dead.',
  },
  {
    id: '1-samuel-3',
    reference: '1 Samuel 3',
    text: 'The child Samuel ministered unto the Lord before Eli. The Lord called Samuel; and Samuel answered, Speak; for thy servant heareth. And Samuel grew, and the Lord was with him, and did let none of his words fall to the ground.',
    context: 'The Lord calls Samuel; an example of answering God’s voice with readiness.',
  },
  {
    id: '1-timothy-4-12',
    reference: '1 Timothy 4:12',
    text: 'Let no man despise thy youth; but be thou an example of the believers, in word, in conversation, in charity, in spirit, in faith, in purity.',
    verses: [
      {
        verse: 12,
        text: 'Let no man despise thy youth; but be thou an example of the believers, in word, in conversation, in charity, in spirit, in faith, in purity.',
      },
    ],
    context: 'Timothy is counseled to be an example of the believer despite his youth.',
  },
  {
    id: '2-timothy-3-16-17',
    reference: '2 Timothy 3:16–17',
    text: 'All scripture is given by inspiration of God, and is profitable for doctrine, for reproof, for correction, for instruction in righteousness: That the man of God may be perfect, throughly furnished unto all good works.',
    verses: [
      {
        verse: 16,
        text: 'All scripture is given by inspiration of God, and is profitable for doctrine, for reproof, for correction, for instruction in righteousness:',
      },
      {
        verse: 17,
        text: 'That the man of God may be perfect, throughly furnished unto all good works.',
      },
    ],
    context: 'Scripture equips us for teaching and righteous living.',
  },
  {
    id: '3-nephi-17-3',
    reference: '3 Nephi 17:3',
    text: 'Therefore, go ye unto your homes, and ponder upon the things which I have said, and ask of the Father, in my name, that ye may understand, and prepare your minds for the morrow, and I come unto you again.',
    verses: [
      {
        verse: 3,
        text: 'Therefore, go ye unto your homes, and ponder upon the things which I have said, and ask of the Father, in my name, that ye may understand, and prepare your minds for the morrow, and I come unto you again.',
      },
    ],
    context: 'Jesus invites His disciples to ponder, pray, and prepare for His return.',
  },
  {
    id: '3-nephi-18-18-20',
    reference: '3 Nephi 18:18–20',
    text: 'Behold, verily, verily, I say unto you, ye must watch and pray always lest ye enter into temptation; for Satan desireth to have you, that he may sift you as wheat. Therefore ye must always pray unto the Father in my name; And whatsoever ye shall ask the Father in my name, which is right, believing that ye shall receive, behold it shall be given unto you.',
    verses: [
      {
        verse: 18,
        text: 'Behold, verily, verily, I say unto you, ye must watch and pray always lest ye enter into temptation; for Satan desireth to have you, that he may sift you as wheat.',
      },
      {
        verse: 19,
        text: 'Therefore ye must always pray unto the Father in my name;',
      },
      {
        verse: 20,
        text: 'And whatsoever ye shall ask the Father in my name, which is right, believing that ye shall receive, behold it shall be given unto you.',
      },
    ],
    context: 'Christ teaches prayer in His name and perseverance in prayer.',
  },
  {
    id: '3-nephi-18-21',
    reference: '3 Nephi 18:21',
    text: 'Pray in your families unto the Father, always in my name, that your wives and your children may be blessed.',
    verses: [
      {
        verse: 21,
        text: 'Pray in your families unto the Father, always in my name, that your wives and your children may be blessed.',
      },
    ],
    context: 'Family prayer in the name of Christ.',
  },
  {
    id: '3-nephi-18-28-29',
    reference: '3 Nephi 18:28–29',
    text: 'And now behold, this is the commandment which I give unto you, that ye shall not suffer any one knowingly to partake of my flesh and blood unworthily, when ye shall minister it; For whoso eateth and drinketh my flesh and blood unworthily eateth and drinketh damnation to his soul; therefore if ye know that a man is unworthy to eat and drink of my flesh and blood ye shall forbid him.',
    verses: [
      {
        verse: 28,
        text: 'And now behold, this is the commandment which I give unto you, that ye shall not suffer any one knowingly to partake of my flesh and blood unworthily, when ye shall minister it;',
      },
      {
        verse: 29,
        text: 'For whoso eateth and drinketh my flesh and blood unworthily eateth and drinketh damnation to his soul; therefore if ye know that a man is unworthy to eat and drink of my flesh and blood ye shall forbid him.',
      },
    ],
    context: 'Worthily partaking of the sacrament and ministering with discernment.',
  },
  {
    id: 'acts-2-42-47',
    reference: 'Acts 2:42–47',
    text: 'And they continued stedfastly in the apostles\' doctrine and fellowship, and in breaking of bread, and in prayers. And fear came upon every soul: and many wonders and signs were done by the apostles. And all that believed were together, and had all things common; And sold their possessions and goods, and parted them to all men, as every man had need. And they, continuing daily with one accord in the temple, and breaking bread from house to house, did eat their meat with gladness and singleness of heart, Praising God, and having favour with all the people. And the Lord added to the church daily such as should be saved.',
    verses: [
      { verse: 42, text: 'And they continued stedfastly in the apostles\' doctrine and fellowship, and in breaking of bread, and in prayers.' },
      { verse: 43, text: 'And fear came upon every soul: and many wonders and signs were done by the apostles.' },
      { verse: 44, text: 'And all that believed were together, and had all things common;' },
      { verse: 45, text: 'And sold their possessions and goods, and parted them to all men, as every man had need.' },
      { verse: 46, text: 'And they, continuing daily with one accord in the temple, and breaking bread from house to house, did eat their meat with gladness and singleness of heart,' },
      { verse: 47, text: 'Praising God, and having favour with all the people. And the Lord added to the church daily such as should be saved.' },
    ],
    context: 'The life of the primitive church: doctrine, fellowship, bread, and prayer.',
  },
  {
    id: 'alma-34-38',
    reference: 'Alma 34:38',
    text: 'That ye contend no more against the Holy Ghost, but that ye receive it, and take upon you the name of Christ; that ye humble yourselves even to the dust, and worship God, in whatsoever place ye may be in, in spirit and in truth; and that ye live in thanksgiving daily, for the many mercies and blessings which he doth bestow upon you.',
    verses: [
      {
        verse: 38,
        text: 'That ye contend no more against the Holy Ghost, but that ye receive it, and take upon you the name of Christ; that ye humble yourselves even to the dust, and worship God, in whatsoever place ye may be in, in spirit and in truth; and that ye live in thanksgiving daily, for the many mercies and blessings which he doth bestow upon you.',
      },
    ],
    context: 'Amulek exhorts us to receive the Holy Ghost, take Christ’s name, and give thanks.',
  },
  {
    id: 'dc-107-head',
    reference: 'Doctrine and Covenants 107',
    text: 'There are, in the church, two priesthoods, namely, the Melchizedek and Aaronic, including the Levitical Priesthood. Why the first is called the Melchizedek Priesthood is because Melchizedek was such a great high priest.',
    verses: [
      {
        verse: 1,
        text: 'There are, in the church, two priesthoods, namely, the Melchizedek and Aaronic, including the Levitical Priesthood.',
      },
      {
        verse: 2,
        text: 'Why the first is called the Melchizedek Priesthood is because Melchizedek was such a great high priest.',
      },
    ],
    context: 'Opening of the revelation on the two priesthoods in the Church.',
  },
  {
    id: 'dc-107-8-9',
    reference: 'Doctrine and Covenants 107:8–9',
    text: 'The Melchizedek Priesthood holds the right of presidency, and has power and authority over all the offices in the church in all ages of the world, to administer in spiritual things. The presidency of the High Priesthood, after the order of Melchizedek, have a right to officiate in all the offices in the church.',
    verses: [
      {
        verse: 8,
        text: 'The Melchizedek Priesthood holds the right of presidency, and has power and authority over all the offices in the church in all ages of the world, to administer in spiritual things.',
      },
      {
        verse: 9,
        text: 'The presidency of the High Priesthood, after the order of Melchizedek, have a right to officiate in all the offices in the church.',
      },
    ],
    context: 'Authority of the Melchizedek Priesthood and its presidency.',
  },
  {
    id: 'dc-124-39',
    reference: 'Doctrine and Covenants 124:39',
    text: 'That when this house shall be completed, if the king and his counselors, the high priest and his counselors, the elders among you, shall grow and flourish in the land, ye may grow up into a holy nation, a kingdom and dominion unto me.',
    verses: [
      {
        verse: 39,
        text: 'That when this house shall be completed, if the king and his counselors, the high priest and his counselors, the elders among you, shall grow and flourish in the land, ye may grow up into a holy nation, a kingdom and dominion unto me.',
      },
    ],
    context: 'The purpose of the temple and preparing God’s people.',
  },
  {
    id: 'dc-20-46-59',
    reference: 'Doctrine and Covenants 20:46–59',
    text: 'Duties of priest, teacher, and deacon in the revealed organization of the Church.',
    verses: [
      {
        verse: 46,
        text: 'The priest\'s duty is to preach, teach, expound, exhort, and baptize, and administer the sacrament,',
      },
      {
        verse: 47,
        text: 'And visit the house of each member, and exhort them to pray vocally and in secret and attend to all family duties.',
      },
      {
        verse: 48,
        text: 'And he may also ordain other priests, teachers, and deacons.',
      },
      {
        verse: 49,
        text: 'And he is to take the lead of meetings when there is no elder present;',
      },
      {
        verse: 50,
        text: 'But when there is an elder present, he is only to preach, teach, expound, exhort, and baptize,',
      },
      {
        verse: 51,
        text: 'And visit the house of each member, exhorting them to pray vocally and in secret and attend to all family duties.',
      },
      {
        verse: 52,
        text: 'In all these duties the priest is to assist the elder if occasion requires.',
      },
      {
        verse: 53,
        text: 'The teacher\'s duty is to watch over the church always, and be with and strengthen them;',
      },
      {
        verse: 54,
        text: 'And see that there is no iniquity in the church, neither hardness with each other, neither lying, backbiting, nor evil speaking;',
      },
      {
        verse: 55,
        text: 'And see that the church meet together often, and also see that all the members do their duty.',
      },
      {
        verse: 56,
        text: 'And he is to take the lead of meetings in the absence of the elder or priest—',
      },
      {
        verse: 57,
        text: 'And is to be assisted always, in all his duties in the church, by the deacons, if occasion requires.',
      },
      {
        verse: 58,
        text: 'But neither teachers nor deacons have authority to baptize, administer the sacrament, or lay on hands;',
      },
      {
        verse: 59,
        text: 'They are, however, to warn, expound, exhort, and teach, and invite all to come unto Christ.',
      },
    ],
    context: 'Doctrine and Covenants 20 describes duties of priests, teachers, and deacons.',
  },
  {
    id: 'dc-84-33-44',
    reference: 'Doctrine and Covenants 84:33–44',
    text: 'For whoso is faithful unto the obtaining these two priesthoods of which I have spoken, and the magnifying their calling, are sanctified by the Spirit unto the renewing of their bodies. They become the sons of Moses and of Aaron and the seed of Abraham, and the church and kingdom, and the elect of God. And also all they who receive this priesthood receive me, saith the Lord; For he that receiveth my servants receiveth me; And he that receiveth me receiveth my Father; And he that receiveth my Father receiveth my Father\'s kingdom; therefore all that my Father hath shall be given unto him. And this is according to the oath and the covenant which belongeth to the priesthood. Therefore, all those who receive the priesthood, receive this oath and covenant of my Father, which he cannot break, neither can it be moved. But whoso breaketh this covenant after he hath received it, and altogether turneth therefrom, shall not have forgiveness of sins in this world nor in the world to come. And wo unto all those who come not unto this priesthood which ye have received, which I now confirm upon you who are present this day, by mine own voice out of the heavens; and even I have given the heavenly hosts and mine angels charge concerning you. And I now give unto you a commandment to beware concerning yourselves, to give diligent heed to the words of eternal life. For you shall live by every word that proceedeth forth from the mouth of God.',
    verses: [
      {
        verse: 33,
        text: 'For whoso is faithful unto the obtaining these two priesthoods of which I have spoken, and the magnifying their calling, are sanctified by the Spirit unto the renewing of their bodies.',
      },
      {
        verse: 34,
        text: 'They become the sons of Moses and of Aaron and the seed of Abraham, and the church and kingdom, and the elect of God.',
      },
      { verse: 35, text: 'And also all they who receive this priesthood receive me, saith the Lord;' },
      { verse: 36, text: 'For he that receiveth my servants receiveth me;' },
      { verse: 37, text: 'And he that receiveth me receiveth my Father;' },
      {
        verse: 38,
        text: 'And he that receiveth my Father receiveth my Father\'s kingdom; therefore all that my Father hath shall be given unto him.',
      },
      {
        verse: 39,
        text: 'And this is according to the oath and the covenant which belongeth to the priesthood.',
      },
      {
        verse: 40,
        text: 'Therefore, all those who receive the priesthood, receive this oath and covenant of my Father, which he cannot break, neither can it be moved.',
      },
      {
        verse: 41,
        text: 'But whoso breaketh this covenant after he hath received it, and altogether turneth therefrom, shall not have forgiveness of sins in this world nor in the world to come.',
      },
      {
        verse: 42,
        text: 'And wo unto all those who come not unto this priesthood which ye have received, which I now confirm upon you who are present this day, by mine own voice out of the heavens; and even I have given the heavenly hosts and mine angels charge concerning you.',
      },
      {
        verse: 43,
        text: 'And I now give unto you a commandment to beware concerning yourselves, to give diligent heed to the words of eternal life.',
      },
      { verse: 44, text: 'For you shall live by every word that proceedeth forth from the mouth of God.' },
    ],
    context: 'The oath and covenant of the priesthood: faithfulness, receiving Christ, and living by God’s word.',
  },
  {
    id: 'dc-97-8',
    reference: 'Doctrine and Covenants 97:8',
    text: 'Verily I say unto you, all among them who know their hearts are honest, and are broken, and their spirits contrite, and are willing to observe their covenants by sacrifice—yea, every sacrifice which I, the Lord, shall command—they are accepted of me.',
    verses: [
      {
        verse: 8,
        text: 'Verily I say unto you, all among them who know their hearts are honest, and are broken, and their spirits contrite, and are willing to observe their covenants by sacrifice—yea, every sacrifice which I, the Lord, shall command—they are accepted of me.',
      },
    ],
    context: 'The Lord accepts those who offer honest hearts and covenant sacrifice.',
  },
  {
    id: 'dc-38-30',
    reference: 'Doctrine and Covenants 38:30',
    text: 'I tell you these things because of your prayers; wherefore, treasure up wisdom in your bosoms, lest the wickedness of men reveal these things unto you by their wickedness, in a manner which shall speak in your ears with a voice louder than that which shall shake the earth; but if ye are prepared ye shall not fear.',
    verses: [
      {
        verse: 30,
        text: 'I tell you these things because of your prayers; wherefore, treasure up wisdom in your bosoms, lest the wickedness of men reveal these things unto you by their wickedness, in a manner which shall speak in your ears with a voice louder than that which shall shake the earth; but if ye are prepared ye shall not fear.',
      },
    ],
    context: 'Treasure up wisdom and prepare spiritually in response to the Lord’s word.',
  },
  {
    id: 'dc-42-14',
    reference: 'Doctrine and Covenants 42:14',
    text: 'And the Spirit shall be given unto you by the prayer of faith; and if ye receive not the Spirit ye shall not teach.',
    verses: [
      {
        verse: 14,
        text: 'And the Spirit shall be given unto you by the prayer of faith; and if ye receive not the Spirit ye shall not teach.',
      },
    ],
    context: 'Teaching in the Church should be supported by the Holy Ghost.',
  },
  {
    id: 'dc-50-13-14',
    reference: 'Doctrine and Covenants 50:13–14',
    text: 'Wherefore, I the Lord ask you this question—unto what were ye ordained? To preach my gospel by the Spirit, even the Comforter which was sent forth to teach the truth.',
    verses: [
      {
        verse: 13,
        text: 'Wherefore, I the Lord ask you this question—unto what were ye ordained?',
      },
      {
        verse: 14,
        text: 'To preach my gospel by the Spirit, even the Comforter which was sent forth to teach the truth.',
      },
    ],
    context: 'Preach the gospel by the Spirit, the Comforter sent to teach truth.',
  },
  {
    id: 'dc-64-10-11',
    reference: 'Doctrine and Covenants 64:10–11',
    text: 'I, the Lord, will forgive whom I will forgive, but of you it is required to forgive all men. And ye ought to say in your hearts—let God judge between me and thee, and reward thee according to thy deeds.',
    verses: [
      {
        verse: 10,
        text: 'I, the Lord, will forgive whom I will forgive, but of you it is required to forgive all men.',
      },
      {
        verse: 11,
        text: 'And ye ought to say in your hearts—let God judge between me and thee, and reward thee according to thy deeds.',
      },
    ],
    context: 'Forgiveness and faithfulness to the covenant.',
  },
  {
    id: 'dc-8-2',
    reference: 'Doctrine and Covenants 8:2',
    text: 'Yea, behold, I will tell you in your mind and in your heart, by the Holy Ghost, which shall come upon you and which shall dwell in your heart.',
    verses: [
      {
        verse: 2,
        text: 'Yea, behold, I will tell you in your mind and in your heart, by the Holy Ghost, which shall come upon you and which shall dwell in your heart.',
      },
    ],
    context: 'How the Spirit reveals truth in mind and heart.',
  },
  {
    id: 'dc-88-118',
    reference: 'Doctrine and Covenants 88:118',
    text: 'And as all have not faith, seek ye diligently and teach one another words of wisdom; yea, seek ye out of the best books words of wisdom; seek learning, even by study and also by faith.',
    verses: [
      {
        verse: 118,
        text: 'And as all have not faith, seek ye diligently and teach one another words of wisdom; yea, seek ye out of the best books words of wisdom; seek learning, even by study and also by faith.',
      },
    ],
    context: 'Study, faith, and teaching one another in Christ.',
  },
  {
    id: 'dc-88-119',
    reference: 'Doctrine and Covenants 88:119',
    text: 'Organize yourselves; prepare every needful thing; and establish a house, even a house of prayer, a house of fasting, a house of faith, a house of learning, a house of glory, a house of order, a house of God;',
    verses: [
      {
        verse: 119,
        text: 'Organize yourselves; prepare every needful thing; and establish a house, even a house of prayer, a house of fasting, a house of faith, a house of learning, a house of glory, a house of order, a house of God;',
      },
    ],
    context: 'Order and holiness in the home and in the Church.',
  },
  {
    id: 'dc-88-77',
    reference: 'Doctrine and Covenants 88:77',
    text: 'And I give unto you a commandment that you shall teach one another the doctrine of the kingdom.',
    verses: [
      {
        verse: 77,
        text: 'And I give unto you a commandment that you shall teach one another the doctrine of the kingdom.',
      },
    ],
    context: 'Teaching one another the doctrine of the kingdom.',
  },
  {
    id: 'john-13-34-35',
    reference: 'John 13:34–35',
    text: 'A new commandment I give unto you, That ye love one another; as I have loved you, that ye also love one another. By this shall all men know that ye are my disciples, if ye have love one to another.',
    verses: [
      {
        verse: 34,
        text: 'A new commandment I give unto you, That ye love one another; as I have loved you, that ye also love one another.',
      },
      {
        verse: 35,
        text: 'By this shall all men know that ye are my disciples, if ye have love one to another.',
      },
    ],
    context: 'The Savior’s commandment to love one another.',
  },
  {
    id: 'john-17-3',
    reference: 'John 17:3',
    text: 'And this is life eternal, that they might know thee the only true God, and Jesus Christ, whom thou hast sent.',
    verses: [
      {
        verse: 3,
        text: 'And this is life eternal, that they might know thee the only true God, and Jesus Christ, whom thou hast sent.',
      },
    ],
    context: 'Eternal life is to know the Father and Jesus Christ.',
  },
  {
    id: 'luke-22-26-27',
    reference: 'Luke 22:26–27',
    text: 'But ye shall not be so: but he that is greatest among you, let him be as the younger; and he that is chief, as he that doth serve. For whether is greater, he that sitteth at meat, or he that serveth? is not he that sitteth at meat? but I am among you as he that serveth.',
    verses: [
      {
        verse: 26,
        text: 'But ye shall not be so: but he that is greatest among you, let him be as the younger; and he that is chief, as he that doth serve.',
      },
      {
        verse: 27,
        text: 'For whether is greater, he that sitteth at meat, or he that serveth? is not he that sitteth at meat? but I am among you as he that serveth.',
      },
    ],
    context: 'Jesus Christ teaches leadership as service.',
  },
  {
    id: 'matthew-19-14',
    reference: 'Matthew 19:14',
    text: 'But Jesus said, Suffer little children, and forbid them not, to come unto me: for of such is the kingdom of heaven.',
    verses: [
      {
        verse: 14,
        text: 'But Jesus said, Suffer little children, and forbid them not, to come unto me: for of such is the kingdom of heaven.',
      },
    ],
    context: 'Jesus welcomes children and their faith.',
  },
  {
    id: 'moroni-10-32',
    reference: 'Moroni 10:32',
    text: 'Yea, come unto Christ, and be perfected in him, and deny yourselves of all ungodliness; and if ye shall deny yourselves of all ungodliness, and love God with all your might, mind and strength, then is his grace sufficient for you, that by his grace ye may be perfect in Christ; and if by the grace of God ye are perfect in Christ, ye can in nowise deny the power of God.',
    verses: [
      {
        verse: 32,
        text: 'Yea, come unto Christ, and be perfected in him, and deny yourselves of all ungodliness; and if ye shall deny yourselves of all ungodliness, and love God with all your might, mind and strength, then is his grace sufficient for you, that by his grace ye may be perfect in Christ; and if by the grace of God ye are perfect in Christ, ye can in nowise deny the power of God.',
      },
    ],
    context: 'Moroni’s final invitation to come unto Christ.',
  },
  {
    id: 'moroni-7-45',
    reference: 'Moroni 7:45',
    text: 'And charity suffereth long, and is kind, and envieth not, and is not puffed up, seeketh not her own, is not easily provoked, thinketh no evil;',
    verses: [
      {
        verse: 45,
        text: 'And charity suffereth long, and is kind, and envieth not, and is not puffed up, seeketh not her own, is not easily provoked, thinketh no evil;',
      },
    ],
    context: 'Mormon describes the attributes of true charity.',
  },
  {
    id: 'moroni-8-26',
    reference: 'Moroni 8:26',
    text: 'And the remission of sins bringeth meekness, and lowliness of heart; and because of meekness and lowliness of heart cometh the visitation of the Holy Ghost, which Comforter filleth with hope and perfect love, which love endureth by diligence unto prayer, until the end shall come, when all the saints shall dwell with God.',
    verses: [
      {
        verse: 26,
        text: 'And the remission of sins bringeth meekness, and lowliness of heart; and because of meekness and lowliness of heart cometh the visitation of the Holy Ghost, which Comforter filleth with hope and perfect love, which love endureth by diligence unto prayer, until the end shall come, when all the saints shall dwell with God.',
      },
    ],
    context: 'Mormon teaches that remission of sins opens the way to the Holy Ghost and enduring love.',
  },
  {
    id: 'mosiah-18-21',
    reference: 'Mosiah 18:21',
    text: 'And he commanded them that there should be no contention one with another, but that they should look forward with one eye, having one faith and one baptism, having their hearts knit together in unity and in love one towards another.',
    verses: [
      {
        verse: 21,
        text: 'And he commanded them that there should be no contention one with another, but that they should look forward with one eye, having one faith and one baptism, having their hearts knit together in unity and in love one towards another.',
      },
    ],
    context: 'Alma commands unity, one faith, and love among those baptized at Mormon.',
  },
  {
    id: 'mosiah-5-chapter',
    reference: 'Mosiah 5',
    text: 'The people covenant to take upon themselves the name of Christ and to serve Him. King Benjamin exhorts them to remember the covenant and be faithful unto the end.',
    context: 'A Book of Mormon chapter on the people’s covenant after Benjamin’s teachings.',
  },
  {
    id: 'proverbs-15-22',
    reference: 'Proverbs 15:22',
    text: 'Without counsel purposes are disappointed: but in the multitude of counsellers they are established.',
    verses: [
      {
        verse: 22,
        text: 'Without counsel purposes are disappointed: but in the multitude of counsellers they are established.',
      },
    ],
    context: 'The wisdom of seeking counsel.',
  },
  {
    id: 'proverbs-31-20',
    reference: 'Proverbs 31:20',
    text: 'She stretcheth out her hand to the poor; yea, she reacheth forth her hands to the needy.',
    verses: [
      {
        verse: 20,
        text: 'She stretcheth out her hand to the poor; yea, she reacheth forth her hands to the needy.',
      },
    ],
    context: 'The virtuous woman serves with compassion.',
  },
  {
    id: 'psalms-24-3-4',
    reference: 'Psalms 24:3–4',
    text: 'Who shall ascend into the hill of the Lord? or who shall stand in his holy place? He that hath clean hands, and a pure heart; who hath not lifted up his soul unto vanity, nor sworn deceitfully.',
    verses: [
      {
        verse: 3,
        text: 'Who shall ascend into the hill of the Lord? or who shall stand in his holy place?',
      },
      {
        verse: 4,
        text: 'He that hath clean hands, and a pure heart; who hath not lifted up his soul unto vanity, nor sworn deceitfully.',
      },
    ],
    context: 'Who may draw near to God’s presence.',
  },
];
